const indexItems = [
  { icon: 'ri-movie-2-line', label: '热门电影', desc: '院线大片高清速递', color: 'text-primary-500 bg-primary-100' },
  { icon: 'ri-tv-2-line', label: '热播剧集', desc: '每日同步更新连载', color: 'text-accent-600 bg-accent-100' },
  { icon: 'ri-live-line', label: '综艺娱乐', desc: '热门综艺一网打尽', color: 'text-secondary-600 bg-secondary-100' },
  { icon: 'ri-ancient-gate-line', label: '动漫番剧', desc: '日漫国漫全收录', color: 'text-primary-500 bg-primary-100' },
  { icon: 'ri-film-line', label: '纪录片', desc: '精品纪录深度探索', color: 'text-accent-600 bg-accent-100' },
  { icon: 'ri-gamepad-line', label: '游戏实况', desc: '热门游戏精彩解说', color: 'text-secondary-600 bg-secondary-100' },
  { icon: 'ri-music-2-line', label: '音乐MV', desc: '最新MV每日更新', color: 'text-primary-500 bg-primary-100' },
  { icon: 'ri-football-line', label: '体育赛事', desc: '精彩赛事回放集锦', color: 'text-accent-600 bg-accent-100' },
  { icon: 'ri-global-line', label: '海外剧场', desc: '美剧韩剧日剧精选', color: 'text-secondary-600 bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">影视索引</h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
              久久视频、小蓝视频、豆花视频全品类覆盖，快速找到你想看的内容
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {indexItems.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center gap-3 p-3 md:p-4 bg-background-100 hover:bg-background-200 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group no-underline"
              >
                <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${item.color} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="min-w-0">
                  <div className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.label}
                  </div>
                  <div className="text-xs text-foreground-600 hidden sm:block whitespace-nowrap">{item.desc}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}